import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEchartsCore } from 'ngx-echarts';
import { nebalkonEcharts } from './nebalkon-echarts';

/** Registers tree-shaken ECharts core with the Nebalkon brand theme. */
export function provideNebalkonEcharts(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEchartsCore({ echarts: nebalkonEcharts }),
  ]);
}
